import { useSelector } from "react-redux";
import { RootState } from "./store";
import LoadingScreen from "./components/LoadingScreen";
import { AdminSidebarProvider } from "./contexts/AdminSidebarContext";
import { AccountSettingsModalProvider } from "./contexts/AccountSettingsModalContext";
import { AppRoutes } from "./routes";

function App() {
  const { isInitialized } = useSelector((state: RootState) => state.auth);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return (
    <AdminSidebarProvider>
      <AccountSettingsModalProvider>
        <AppRoutes />
      </AccountSettingsModalProvider>
    </AdminSidebarProvider>
  );
}

export default App;
